import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { Form, Input, Modal , Table, columns} from 'antd';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';
import API from "../scripts/api";

class AdvanceSearchDetailForm extends Component {
    constructor() {
        super();

        this.state = {
            data: []
        };

        this.formRef = React.createRef();
    }



    handleWillUnmount = () => {
        // this.formRef.current.resetFields();
    }

    handleDidMount = async (time, search) => {

    console.log("time", time)
    console.log("search", search)
    await this.getDatail(time, search)
    }

    getDatail = (time, q) => {
       
      
        let params = {
            time : time,
            q : q
        }
        this.setState({ loading: true });
    
        API.advanceSearchReport
          .detail(params)
          .then((result) => {
            if (result.data) {
              this.setState({
                loading: false,
                data: result.data,
               
              });
            } else {
              this.setState({ loading: false });
            }
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      };

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { editMode, data } = this.state;
   const columns = [
     
    
      {
        title: `${Resources.search} `,
        dataIndex: "text",
        className: "col-center",
      },
   
      {
        title: `${Resources.user} `,
        dataIndex: "user",
        className: "col-center",
        render: (val) => val?.name + " "+ val?.family
      },
      {
        title: `${Resources.count} `,
        dataIndex: "total",
        className: "col-center",
      },
    ];
        return (
            <Modal
                // title={editMode ? Resources.edit : Resources.add}
                visible={visible}
                onOk={onCancel}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={1000}>
                <div className="ant-content">
                <Table
                    columns={columns}
                    dataSource={data}
                    // loading={loading}
                    // onChange={this.handleTableChange}
                    pagination={false}
                    size="small"
                    rowKey="id"
                    // scroll={{ x: 1000 }}
                />
                </div>
            </Modal>
        );
    }
};

export default AdvanceSearchDetailForm;